<template>
  <div class="animated fadeIn">
    <b-card no-body>
      <b-card-body>
        <template>
          <b-row>
            <b-col sm="3">
              <b-form-group label-for="customer_group" label="Grup Konsumen">
                <model-select
                  id="customer_group"
                  :options="listCustomerGroup"
                  v-model="myCustomerGroup"
                  placeholder="Grup Konsumen"
                ></model-select>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col lg="12">
              <b-button
                size="sm"
                variant="stack-overflow"
                class="mr-1 btn-brand"
                @click="init"
              >
                <i class="fa fa-search"></i>
                <span>Filter</span>
              </b-button>
            </b-col>
          </b-row>
        </template>
      </b-card-body>
    </b-card>
    
    <b-row>
      <b-col lg="12">
        <b-card class="col-sm-12 col-md-12 col-lg-12">
          <div class="h4 text-muted text-left">
            <i class="icon-graph"></i>&nbsp;Total Order
          </div>
          <div class="text-muted text-left" v-if="periode1">
            <i class="fa fa-loading"></i>&nbsp;Periode Tarikan Data:
            <small
              >{{ dateFormat(periode2.Mon) }} -
              {{ dateFormat(periode1.Sun) }}</small
            >
          </div>

          <!-- <loading v-if="loading"></loading> -->

          <b-button
            v-if="!loading"
            class="btn btn-link"
            variant="excel icon"
            size="sm"
            @click="download"
            ><i class="fa fa-file-excel-o"></i> Export to excel</b-button
          >

          <global-table
            :table-data="data"
            :loading="loading"
            :per-page="7"
            :bordered="true"
            :table-detail="tableDetail"
            :hover="true"
            :striped="false"
            :fields="fields"
            :redirect-detail="false"
            :show-add-button="false"
            :edit-button="false"
          ></global-table>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { Callout } from "@coreui/vue";
import axios from "axios";
import globalTable from "@/templates/Table.vue";
import VueNotifications from "vue-notifications";
import loading from "@/templates/Loading.vue";
import LineExample from "@/views/charts/LineExample.vue";
import DoughnutExample from "@/views/charts/DoughnutExample.vue";
import BarExample from "@/views/charts/BarExample.vue";
import { ModelSelect } from "vue-search-select";

import * as moment from "moment";

import _ from "lodash";
export default {
  name: "dashboard-performance-customer",
  components: {
    globalTable,
    Callout,
    loading,
    LineExample,
    DoughnutExample,
    BarExample,
    ModelSelect,
  },
  props: {
    tableDetail: {
      type: Boolean,
      default: true,
    },
  },
  data: function () {
    return {
      header: [],
      data: [],
      listCustomerGroup: [],
      myCustomerGroup: '1',
      loading: true,
      periode1: null,
      periode2: null,
      fields: [
        { key: "name", label: "Name", sortable: true },
        {
          key: "total",
          label: "Total Order",
          class: "width-150",
          sortable: true,
        },
      ],
    };
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  computed: {
    isMobile: function () {
      let check = false;
      (function (a) {
        if (
          /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
            a
          ) ||
          /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
            a.substr(0, 4)
          )
        )
          check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      if (check === true) {
        if (window.screen.width < 732) {
          return undefined;
        } else {
          return 100;
        }
      } else {
        return 100;
      }
    },
  },
  methods: {
    uniqueId: function (param = "") {
      return _.uniqueId(param);
    },
     dropdown: function () {
      this.axios
        .get("web/dropdown/dashboard-cro/")
        .then((response) => {
          this.listCustomerGroup = response.data.customer_group;
        })
        .catch((error) => {})
        .finally(() => {
          //this.loading = false;
        });
    },
    init: function () {
      this.loading = true;
      this.dropdown();
      this.axios
        .get("/web/performance/customer/calculation/"+this.myCustomerGroup)
        .then((response) => {
          this.header = response.data.header;
          this.data = response.data.data;
          this.periode1 = response.data.periode1;
          this.periode2 = response.data.periode2;
        })
        .catch((error) => {})
        .finally(() => {
          this.loading = false;
        });
    },

    download: function () {
      this.loading = true;
      this.axios({
        url: "web/export/performance/customer/export-to-excel/"+this.myCustomerGroup,
        method: "GET",
        responseType: "arraybuffer", //before "blob"
      })
        .then((response) => {
          console.log(response);
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "performance_all_customer.xlsx");
          document.body.appendChild(link);
          link.click();
        })
        .catch((error) => {
          if (error.response.status === 401) {
            this.expired(error, "");
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    dateFormat: function (date) {
      return date === null ? "" : moment(date).format("DD MMM YYYY");
    },
    expired: function (error) {
      if (error.response.status === 401) {
        localStorage.clear();
        this.$router.push({ path: "/login" });
        this.showErrorNotification({
          title: "Token Expired",
          message: "Your session has been expired",
        });
      } else {
        this.showErrorNotification({
          title: "DashboardProfile",
          message: error.response.data.message,
        });
      }
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style>
ul.timeline {
  list-style-type: none;
  position: relative;
}
ul.timeline:before {
  content: " ";
  background: #d4d9df;
  display: inline-block;
  position: absolute;
  left: 29px;
  width: 2px;
  height: 100%;
  z-index: 400;
}
ul.timeline > li {
  margin: 20px 0;
  padding-left: 20px;
}
ul.timeline > li:before {
  content: " ";
  background: white;
  display: inline-block;
  position: absolute;
  border-radius: 50%;
  border: 3px solid #22c0e8;
  left: 20px;
  width: 20px;
  height: 20px;
  z-index: 400;
}
ul.timeline > li .first-position {
  color: #20a8d8;
}
ul.timeline > li .worst-position {
  color: #c81912;
}
</style>